import { render, staticRenderFns } from "./OrgCascader.vue?vue&type=template&id=3f393a4b&"
import script from "./OrgCascader.vue?vue&type=script&lang=js&"
export * from "./OrgCascader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../wxpush/sources/client/wxpush-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports